export default (Platform: any, id: string) => ({ testID: id });
